import type { CSSProperties, ReactNode } from 'react';
import { COLORS, RADIUS } from '../../theme';

// Minimal shared table primitives for the console's read-only tables. Dark,
// dense, monospace-friendly. No sorting/pagination yet (Phase 1 is read-only).

export function Table({ columns, children }: { columns: string[]; children: ReactNode }) {
  return (
    <div style={frame}>
      <table style={tableStyle}>
        <thead>
          <tr>{columns.map((c) => <th key={c} style={th}>{c}</th>)}</tr>
        </thead>
        <tbody>{children}</tbody>
      </table>
    </div>
  );
}

export function Td({ children, mono, color, nowrap, title }: {
  children: ReactNode; mono?: boolean; color?: string; nowrap?: boolean; title?: string;
}) {
  return (
    <td title={title} style={{
      ...td,
      color: color ?? COLORS.textSecondary,
      fontFamily: mono ? 'ui-monospace, SFMono-Regular, Menlo, monospace' : undefined,
      whiteSpace: nowrap ? 'nowrap' : undefined,
    }}>{children}</td>
  );
}

export function EmptyRow({ span, label }: { span: number; label: string }) {
  return (
    <tr>
      <td colSpan={span} style={{ ...td, color: COLORS.textMuted, textAlign: 'center', padding: '24px 12px' }}>
        {label}
      </td>
    </tr>
  );
}

const frame: CSSProperties = {
  background: COLORS.surface,
  border: `1px solid ${COLORS.border}`,
  borderRadius: RADIUS.card,
  overflow: 'hidden',
};
const tableStyle: CSSProperties = { width: '100%', borderCollapse: 'collapse', fontSize: 12.5 };
const th: CSSProperties = {
  textAlign: 'left', padding: '10px 12px', color: COLORS.textMuted,
  fontSize: 11, fontWeight: 600, letterSpacing: 0.4, textTransform: 'uppercase',
  borderBottom: `1px solid ${COLORS.border}`, background: COLORS.surfaceAlt,
};
const td: CSSProperties = {
  padding: '10px 12px', borderBottom: `1px solid ${COLORS.border}`,
  verticalAlign: 'top',
};
